document.addEventListener("DOMContentLoaded", () => {
  const storeNameEl = document.getElementById("store_name");
  const priceEl = document.getElementById("product_price_input");

  if (!storeNameEl || !priceEl) return;

  const storeName = storeNameEl.value?.trim();
  const price = priceEl.value?.trim();

  if (!storeName || !price) return;

  function extractPriceValue(priceText) {
    const numericPart = priceText.replace(/[^0-9.]/g, "");
    if (!numericPart) return 0;

    const parts = numericPart.split(".");
    return Number(parts.length === 1 ? parts[0] : parts[0] + parts[1]) || 0;
  }

  function formatNumber(number) {
    const num = Number(number) || 0;
    return num % 1 === 0 ? num.toFixed(2) : num.toFixed(2).replace(/\.?0+$/, match => match === ".00" ? ".00" : "");
  }

  function getTargetElement(productChoose) {
    switch (productChoose) {
      case "all":
        return document.getElementById("bonus-tag-for-all");
      case "specific":
        return document.getElementById("bonus-tag-for-original");
      default:
        return document.getElementById("bonus-tag-for-sale");
    }
  }

  function renderBonusTag({ url, textColor, backgroundColor, bonus }) {
    return `
      <a href="${url}" class="sale-price-text" style="padding:4px 20px;color:${textColor};background:${backgroundColor};display:inline-block;margin:14px 0;border-radius:5px;">
        Opptjen ${formatNumber(bonus)} kr i bonus
      </a>
    `;
  }

  const integerValue = extractPriceValue(price);

  fetch("https://dialog.modish.no/api/tag-attributes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      store_name: storeName
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      const {
        percentage = 0,
        background_color: backgroundColor = "",
        text_color: textColor = "",
        product_choose: productChoose = "",
        status = 0,
        url = "#"
      } = data;

      if (Number(status) !== 1) return;

      const bonus = (integerValue * Number(percentage)) / 100;
      const targetElement = getTargetElement(productChoose);

      if (!targetElement) return;

      targetElement.innerHTML = renderBonusTag({
        url,
        textColor,
        backgroundColor,
        bonus
      });
    })
    .catch(error => {
      console.error("Failed to load bonus tag:", error);
    });
});